import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';
import { EItemRecurrenceEditType, ERecursiveAction } from './apply-changes-recursively-question-modal.interface';

@Component({
  imports: [
    MatDialogTitle,
    FormsModule,
    MatDialogContent,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    TranslatePipe,
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton,
  ],
  selector: 'app-apply-changes-recursively-question-modal',
  templateUrl: './apply-changes-recursively-question-modal.component.html',
})
export class ApplyChangesRecursivelyQuestionModalComponent {
  public readonly title =
    this.data.mode === ERecursiveAction.edit
      ? 'page.items.applyChangesRecursivelyQuestionModal.editTitle'
      : 'page.items.applyChangesRecursivelyQuestionModal.deleteTitle';

  public readonly formGroup = new FormGroup({
    editType: new FormControl(EItemRecurrenceEditType.onlyThis, [Validators.required]),
  });

  public EItemEditType = EItemRecurrenceEditType;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      mode: ERecursiveAction;
    },
    private readonly dialogRef: MatDialogRef<ApplyChangesRecursivelyQuestionModalComponent>,
  ) {}

  public onFormDialogSubmit(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this.dialogRef.close(this.formGroup.value.editType);
  }
}
